import {
  Check as CheckIcon,
  Close as CloseIcon,
  AccessTime as ClockIcon,
  Block as BanIcon,
  Warning as WarningIcon,
  CalendarToday as CalendarIcon,
  EventBusy as CalendarOffIcon,
  PieChart as HalfCircleIcon,
  Home as HomeIcon,
  ExitToApp as ExitIcon,
  Assignment as ClipboardIcon,
  DirectionsBus as BusIcon,
  Group as UsersIcon,
  MenuBook as BookIcon,
  EmojiEvents as TrophyIcon,
  Person as UserCheckIcon,
  LocalHospital as MedicalIcon,
  Chat as ChatIcon,
  VerifiedUser as ShieldCheckIcon,
  Computer as ComputerIcon,
  Business as BuildingIcon,
  HelpOutline as QuestionIcon,
  Cancel as CancelIcon
} from "@mui/icons-material";

const IconProvider = ({ icon, color }) => {
const icons = {
  checkMarkIcon: CheckIcon,
  closeIcon: CloseIcon,
  clockIcon: ClockIcon,
  banIcon: BanIcon,
  warningIcon: WarningIcon,
  calendarIcon: CalendarIcon,
  calendarOffIcon: CalendarOffIcon,
  halfCircleIcon: HalfCircleIcon,
  homeIcon: HomeIcon,
  exitIcon: ExitIcon,
  clipboardIcon: ClipboardIcon,
  busIcon: BusIcon,
  usersIcon: UsersIcon,
  bookIcon: BookIcon,
  trophyIcon: TrophyIcon,
  userCheckIcon: UserCheckIcon,
  medicalIcon: MedicalIcon,
  chatIcon: ChatIcon,
  shieldCheckIcon: ShieldCheckIcon,
  computerIcon: ComputerIcon,
  buildingIcon: BuildingIcon,
  questionIcon: QuestionIcon,
  blockIcon: CancelIcon
};

  const IconComponent = icons[icon]

  return IconComponent ? <IconComponent style={{ color, marginRight: '10px' }} /> : null
}

export default IconProvider
